import DPO from 'dpo8core';
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { inject } from '@app/providers/QAU.ContextProvider';
import { setFooterConfig } from '@app/actions/footerActions';
import { processFinishedArtwork, finishArtwork } from '@app/actions/artworkDataActions';
import './AuthorizeCodesFinish.scss';

const AuthorizeCodesFinish = ({ setFooterConfig, flow, context, flowConfig, finishArtwork, processFinishedArtwork }) => {
  const finishAndProcessArtwork = useCallback(() => {
    finishArtwork(flow, context, flowConfig).then(artworkData => {
      processFinishedArtwork(artworkData, flow, flowConfig);
    });
  }, [flow, context, flowConfig, finishArtwork, processFinishedArtwork]);

  const correctAndFinishArtwork = useCallback(() => {
    const corrector = new DPO.project.Corrector(context);
    corrector.on('correction:finished', finishAndProcessArtwork);
    corrector.startCorrection();
  }, [context, finishAndProcessArtwork]);

  useEffect(() => {
    setFooterConfig({
      visible: true,
      backHidden: true,
      nextHidden: false,
      onNext: correctAndFinishArtwork,
      nextLocKey: 'qau-finish-btn',
    });
  }, [setFooterConfig, correctAndFinishArtwork]);

  return (
    <div id="qau-authorize-codes-finish">
      <div className="authorize-codes-title">
        <LocalizedText id="qau-authorization-sent-title" />
      </div>
      <div className="authorize-codes-description">
        <LocalizedText id="qau-authorization-sent-description" />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  processFinishedArtwork,
  setFooterConfig,
  finishArtwork,
};

AuthorizeCodesFinish.propTypes = {
  finishArtwork: PropTypes.func.isRequired,
  setFooterConfig: PropTypes.func.isRequired,
  processFinishedArtwork: PropTypes.func.isRequired,
  flowConfig: PropTypes.object.isRequired,
  flow: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
};

export default inject('flowConfig', 'context', 'flow')(connect(null, mapDispatchToProps)(AuthorizeCodesFinish));
